import { useEffect, useState, useRef } from "react";
import {
  getTaskCommentsApi,
  addTaskCommentApi,
} from '../../app/api'

export default function TaskComments({ taskId }) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  /* ================= FETCH COMMENTS ================= */
  useEffect(() => {
    if (!taskId) return;

    setLoading(true);
    getTaskCommentsApi(taskId)
      .then((res) => setComments(res.data || []))
      .finally(() => setLoading(false));
  }, [taskId]);

  /* ================= AUTO SCROLL ================= */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [comments]);

  /* ================= ADD COMMENT ================= */
  const addComment = async () => {
    if (!comment.trim()) return;

    const res = await addTaskCommentApi(taskId, {
      comment: comment.trim(),
    });

    if (res.success) {
      const refreshed = await getTaskCommentsApi(taskId);
      setComments(refreshed.data || []);
      setComment("");
    }
  };

  if (loading) {
    return (
      <div className="text-sm text-gray-400">
        Loading comments…
      </div>
    );
  }

  return (
    <div className="mt-6">
      <h3 className="font-semibold mb-3">Comments</h3>

      {/* ===== COMMENTS LIST ===== */}
      <div className="space-y-2 max-h-[180px] overflow-y-auto pr-1">
        {comments.length === 0 ? (
          <div className="text-sm text-gray-400 italic">
            No comments yet
          </div>
        ) : (
          comments.map((c) => (
            <div
              key={c.id}
              className="bg-gray-50 border rounded px-3 py-2 text-sm"
            >
              <div className="font-medium text-gray-800">
                {c.user_name || "User"}
              </div>
              <div className="text-gray-700">
                {c.comment}
              </div>
              <div className="text-xs text-gray-400 mt-1">
                {new Date(c.created_at).toLocaleString()}
              </div>
            </div>
          ))
        )}
        <div ref={bottomRef} />
      </div>

      {/* ===== ADD COMMENT ===== */}
      <div className="flex gap-2 mt-3">
        <input
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Write a comment…"
          className="flex-1 border rounded px-2 py-1 text-sm"
        />
        <button
          onClick={addComment}
          className="px-3 py-1 bg-blue-600 text-white rounded text-sm"
        >
          Send
        </button>
      </div>
    </div>
  );
}
